import React, { memo } from 'react';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withUsers } from 'components/dataProviders/withUsers';
import { useUser, withUser } from 'components/dataProviders/withUser';
import { SingleUser } from 'components/user/single';
import { withProcessesData } from 'components/common/withProcessesData';
import { Spinner } from 'components/core';
import { debugLog } from 'shared/logger/debugLog';

function SingleUserView(): React.ReactElement {
  const { loading, user } = useUser();

  if (loading || !user) {
    debugLog('SingleUserView loading || !user', loading, user);
    return <Spinner reason='SingleUserView loading || !user' />;
  }

  return <SingleUser {...user} />;
}

export const MemoUser = memo(
  composeHOCs(
    withProcessesData,
    withUsers,
    withUser
  )(SingleUserView)
);
